import { StoreState } from '../../store';

export const selectScriptCategoriesByCreator = (creatorId: string) => (state: StoreState) => {
  const entry = state.script?.categoriesByCreator.find((e: { creatorId: string }) => e.creatorId === creatorId);
  return entry?.categories || [];
};

export const selectScriptLoading = (state: StoreState) => state.script?.loading;
export const selectScriptError = (state: StoreState) => state.script?.error;

// Build key helper
const keyOf = (creatorId?: string, filterOrCategoryId?: string) => `${creatorId || ''}__${filterOrCategoryId || 'all'}`;

export const selectScriptsByCreatorAndFilter = (creatorId: string, filterOrCategoryId: string) => (state: StoreState) => {
  const key = keyOf(creatorId, filterOrCategoryId);
  const entry = state.script?.scriptsByKey.find((e: { key: string }) => e.key === key);
  return entry || { key, items: [], page: 0, totalPages: 0 };
};

export const selectScriptsLoadingByCreatorAndFilter = (creatorId: string, filterOrCategoryId: string) => (state: StoreState) => {
  const key = keyOf(creatorId, filterOrCategoryId);
  return state.script?.loadingByKey[key];
};
